<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UxMtoB/tc-custom/9781936932863.jpg?1737679392638" alt="This image is the cover for the book Names of All the Flowers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Names of All the Flowers
      </h1>
      <p class="bookDescription body article font2">
        <b>A “poignant, painful, and gorgeous” memoir that explores siblinghood, adolescence, and grief for a family shattered by loss (Alicia Garza, cocreator, Black Lives Matter).</b><br/><br/>Melissa and her older brother Junior grow up running around the disparate neighborhoods of 1990s Oakland, two of six children to a white Quaker father and a black Southern mother. But as Junior approaches adolescence, a bullying incident and later a violent attack in school leave him searching for power and a sense of self in all the wrong places; he develops a hard front and falls into drug dealing. Right before Junior’s twentieth birthday, the family is torn apart when he is murdered as a result of gun violence.<br/><br/>The Names of All the Flowers connects one tragic death to a collective grief for all black people who die too young. A lyrical recounting of a life lost, Melissa Valentine’s debut memoir is an intimate portrait of a family fractured by the school-to-prison pipeline and an enduring love letter to an adored older brother. It is a call for justice amid endless cycles of violence, grief, and trauma, declaring: “We are all witness and therefore no one is spared from this loss.”<br/><br/><b>“A portrait of a place, a person who died too young, the systems that led to that death, and the keen insights of the author herself. Lyrical and smart, with appropriate undercurrents of rage.” —Emily Raboteau, author of Searching for Zion</b><br/><br/><b>“Eloquently poignant.” —Kirkus Reviews</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melissa Valentine
      </h2>
      
      <p class="authorDescription body article">Melissa Valentine is a writer from Oakland, CA. She earned her BA from Sarah Lawrence College and her MFA in creative writing from Mills College. She has been a fellow at the San Francisco Writers' Grotto, and her work has appeared in Jezebel, Guernica, Apogee Journal, and others. Her writing has received honorable mention from Glimmer Train and the Ardella Mills Non-fiction Award. She currently lives in Brooklyn, NY.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21f022d6